<script setup>
import { useSidebarState } from '@/core/components/dss-sidebar/composables/use-sidebar-state'
import { MENU_ITEM_STYLES, TRANSITION_DURATIONS } from '../constants/sidebar.constants'

const { collapsed, toggleSidebar } = useSidebarState()
</script>

<template>
  <button
    type="button"
    class="flex items-center justify-center box-border text-sm text-dss-surface-650 border border-dss-surface-200 rounded-md bg-white dark:bg-dss-surface-100 cursor-pointer hover:!bg-dss-surface-60 transition-colors duration-200 flex-shrink-0 px-[0.625rem] pl-[0.625rem]"
    :class="[MENU_ITEM_STYLES.BUTTON_WIDTH, MENU_ITEM_STYLES.HEIGHT, TRANSITION_DURATIONS.OPACITY]"
    :aria-pressed="collapsed"
    @click="toggleSidebar"
  >
    <i
      v-if="!collapsed"
      class="pi pi-times"
    />
    <i
      v-else
      class="pi pi-bars"
    />
  </button>
</template>
